export const ErrorMessages ={
    PASSWORD_LENGTH_6:'Password should be greater then 6 character.',
    PASSWORD_MISMATCH:'Please make sure your passwords match.',
    ALL_FIELDS_MANDATORY:'All fields are Mandatory.'

}


// WEBPACK FOOTER //
// ./src/components/constants.js